import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';
import { ISimulationActions } from '../types/ISimulationActions';

export class GetSimulationActionsRequest extends Request<ISingleIdParams, ISimulationActions> {
  constructor(id: string) {
    super('getSimulationActions', { id: id });
  }
}
